module.exports = __webpack_public_path__ + "img/144.061b43be.jpg";